<template lang="html">
  <div class="restwaarde text-center" id="restwaarde">
    <h2>Restwaarde en Onderhoud</h2>
    <h4 class="text-color text-inherit">Verwachtte restwaarde en onderhoud voor de {{type.cMerknaam}} {{type.cModelnaam}} {{type.cTypenaam_2}} zijn</h4>

    <p class="text-color">
      <span>Reparatie en onderhoud</span> per maand, bij {{restwaarde.nLooptijd}} maanden en {{String(restwaarde.nKilometrage).replace(/\B(?=(\d{3})+(?!\d))/g, ".")}} km per jaar <span>&euro; {{parseInt(restwaarde.nMaintenance)}},-</span>
    </p>
    <p class="text-color">
      <span>Restwaarde</span> na {{restwaarde.nLooptijd}} maanden en {{String(restwaarde.nKilometrage).replace(/\B(?=(\d{3})+(?!\d))/g, ".")}} km per jaar <span>&euro; {{restwaarde.nVerkoopwaarde.replace(/\B(?=(\d{3})+(?!\d))/g, ".")}},-</span>
    </p>
  </div>
</template>

<script>
export default {
  props:['type', 'restwaarde'],
}
</script>

<style lang="scss" scoped>
#restwaarde{
  padding: 50px 10px;
  background:#2ecc71;
  p{
    font-family: "Poppins",sans-serif;
    font-weight: 600;
    
    // color:#fff;
    padding: 0;
    margin:0;
    font-size: 16px;
  }
  span{
    color:#fff;
    border-bottom: 3px solid lighten(#2ecc71, 10%)
    //color: darken(#2ecc71, 20%);
    //color: lighten(#2ecc71, 40%);
  }
  .text-color{
    //color: lighten(#2ecc71, 40%);
    color: #fff;
  }
  h2{
    font-size: 24px;
    color:#fff;
    @media (min-width: 768px) {
      font-size: 30px;
    }
  }
}
</style>